import { Stack } from "@mui/material";
import type { FC } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { InspirationTimeline } from "web_myplann/Inspiration/Components/InspirationTimeline";
import { EarlyFreedomCapitalSection } from "web_myplann/Inspiration/EarlyFreedom/Components/EarlyFreedomCapitalSection";
import { EarlyFreedomPaceSection } from "web_myplann/Inspiration/EarlyFreedom/Components/EarlyFreedomPaceSection";
import { EarlyFreedomPassiveSection } from "web_myplann/Inspiration/EarlyFreedom/Components/EarlyFreedomPassiveSection";
import { EarlyFreedomReadyBox } from "web_myplann/Inspiration/EarlyFreedom/Components/EarlyFreedomReadyBox";
import { EarlyFreedomTargetSection } from "web_myplann/Inspiration/EarlyFreedom/Components/EarlyFreedomTargetSection";
import { EARLY_FREEDOM_PHASES } from "web_myplann/Inspiration/EarlyFreedom/constants";
import type {
	EarlyFreedomContext,
	EarlyFreedomScenarioKey,
} from "web_myplann/Inspiration/EarlyFreedom/Types/EarlyFreedomTypes";

type Props = {
	context: EarlyFreedomContext;
	onChangeTarget: (value: number) => void;
	onChangeSaving: (value: number) => void;
	onSelectScenario: (scenario: EarlyFreedomScenarioKey) => void;
	onEditIncome: () => void;
	onContact: () => void;
};

export const EarlyFreedomResult: FC<Props> = ({
	context,
	onChangeTarget,
	onChangeSaving,
	onSelectScenario,
	onEditIncome,
	onContact,
}) => {
	const { t } = useResource();

	return (
		<Stack mt={0.8} gap={0.8}>
			<EarlyFreedomTargetSection
				targetExpenses={context.targetExpenses}
				activeAnchorKey={context.activeAnchorKey}
				onChange={onChangeTarget}
			/>
			<EarlyFreedomPassiveSection context={context} onEdit={onEditIncome} />
			{context.isEarlyFreedomReady ? (
				<EarlyFreedomReadyBox context={context} onContact={onContact} />
			) : (
				<>
					<EarlyFreedomCapitalSection context={context} />
					<EarlyFreedomPaceSection
						context={context}
						onChange={onChangeSaving}
						onSelectScenario={onSelectScenario}
					/>
				</>
			)}
			<InspirationTimeline
				title={t(Resources.Inspiration.EarlyFreedom.phasesTitle)}
				steps={EARLY_FREEDOM_PHASES}
			/>
		</Stack>
	);
};
